import { isWeb } from '../src/utils/platformUtils'
import DatabaseSingleton from '../database-sqlite/DatabaseSingleton'
import { GAMIFICATION_STORE_NAMES } from '../src/db/constants'

// Exportar GAMIFICATION_STORE_NAMES para uso en otros archivos
export { GAMIFICATION_STORE_NAMES }

// ✅ MIGRADO: openDatabase() eliminado - ahora usamos getRealDatabase() del DatabaseSingleton
// Para obtener la DB, usar: const realDb = await getRealDatabase()

// ✅ Importar getRealDatabase desde DatabaseSingleton (única fuente de verdad)
import { getRealDatabase } from '../database-sqlite/DatabaseSingleton'

class gamificationServices {
    constructor() {
        // Todos los métodos usan getRealDatabase() directamente
    }

    saveGame = async (game_id, level_id, status, body) => {
        // En web no persistimos juegos pendientes (no hay store dedicado). Salida segura.
        if (isWeb()) {
            return Promise.resolve(null)
        }
        
        return new Promise(async (resolve, reject) => {
            try {
                const realDb = await getRealDatabase()
                const query = `INSERT OR REPLACE INTO ${GAMIFICATION_STORE_NAMES.GAME_PENDING_SEND} (game_id, level_id, status, body) VALUES (?, ?, ?, ?)`
                const newBody = JSON.stringify(body)
                const result = await realDb.runAsync(query, [game_id, level_id, status, newBody])
                console.log('Saved game with ID:', result.lastInsertRowId)
                resolve({ _id: result.lastInsertRowId, game_id, level_id, status, body: newBody })
            } catch (error) {
                console.error('Error al guardar las respuestas:', error)
                reject(error)
            }
        })
    }
    getPendingGames = async () => {
        if (isWeb()) {
            return Promise.resolve([])
        }
        
        return new Promise(async (resolve, reject) => {
            try {
                const realDb = await getRealDatabase()
                const query = `SELECT * from ${GAMIFICATION_STORE_NAMES.GAME_PENDING_SEND} ORDER BY _id ASC`
                const pendingGames = await realDb.getAllAsync(query)
                
                if (pendingGames && pendingGames.length > 0) {
                    console.log('Recovered games:', JSON.stringify(pendingGames))
                    resolve(pendingGames)
                } else {
                    console.log('No se encontraron Games pendientes de envío')
                    resolve([])
                }
            } catch (error) {
                console.error('Error al obtener las respuestas:', error)
                reject(error)
            }
        })
    }
    deleteGameById = async (game_id, level_id) => {
        if (isWeb()) {
            return Promise.resolve()
        }
        
        return new Promise(async (resolve, reject) => {
            try {
                const realDb = await getRealDatabase()
                const query = `DELETE FROM ${GAMIFICATION_STORE_NAMES.GAME_PENDING_SEND} WHERE game_id = ? AND level_id = ?`
                const result = await realDb.runAsync(query, [game_id, level_id])
                console.log(`Deleted game: ${game_id}`)
                resolve(result)
            } catch (error) {
                console.error('Error deleting game:', error)
                reject(error)
            }
        })
    }
}
export const GamificationServices = new gamificationServices()
